const LoginCategory = 'login';
const LoginCompletedAction = 'login';

export { LoginCategory, LoginCompletedAction };
